import { render, staticRenderFns } from "./bot-channel-form.vue?vue&type=template&id=34947192&scoped=true&"
import script from "./bot-channel-form.vue?vue&type=script&lang=js&"
export * from "./bot-channel-form.vue?vue&type=script&lang=js&"
import style0 from "./bot-channel-form.vue?vue&type=style&index=0&id=34947192&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34947192",
  null
  
)

export default component.exports